import questionSetsData from '../questions.json';

/**
 * Picks one random question from each question set, maintaining set order
 * @returns {Object} An object with setInfo and questions array (5 questions total, one from each set)
 */
export const getQuestionsFromAllSets = () => {
  const { questionSets } = questionSetsData;
  
  if (!questionSets || questionSets.length === 0) {
    throw new Error('No question sets available');
  }
  
  const selectedQuestions = [];
  const setNames = [];
  
  // Pick one random question from each set in order
  questionSets.forEach((questionSet, setIndex) => {
    if (!questionSet.questions || questionSet.questions.length === 0) {
      throw new Error(`No questions available in set ${questionSet.id}`);
    }
    
    // Generate random index for this set's questions
    const randomIndex = Math.floor(Math.random() * questionSet.questions.length);
    const selectedQuestion = questionSet.questions[randomIndex];
    
    // Add set information to the question for tracking
    const questionWithSetInfo = {
      ...selectedQuestion,
      setId: questionSet.id,
      setName: questionSet.name,
      originalSetIndex: setIndex
    };
    
    selectedQuestions.push(questionWithSetInfo);
    setNames.push(questionSet.name);
  });
  
  return {
    setInfo: {
      id: 'mixed',
      name: 'Mixed Questions from All Sets',
      setNames: setNames
    },
    questions: selectedQuestions
  };
};

/**
 * Randomly selects a question set from the available question sets
 * @returns {Object} A randomly selected question set with questions array
 */
export const getRandomQuestionSet = () => {
  // Use the new mixed questions logic instead of random set selection
  return getQuestionsFromAllSets();
};

/**
 * Gets all available question sets (for debugging or selection UI)
 * @returns {Array} Array of all question sets
 */
export const getAllQuestionSets = () => {
  return questionSetsData.questionSets;
}; 